import {
  canonicalizeLocale,
  DEFAULT_CONTENT_LOCALE,
  type LocaleOption,
} from '@course-authoring/shared-types';
import { UI_LANGUAGE_OPTIONS } from '@course-authoring/i18n';

export interface ResolveLanguagePanelOptionsInput {
  accountSelectedLanguages: string;
}

/**
 * Resolves learner-facing language eligibility independently from content
 * availability. A configured account selects from every UI locale bundled in
 * the player, including locales for which the current content is untranslated.
 */
export function resolveLanguagePanelOptions({
  accountSelectedLanguages,
}: ResolveLanguagePanelOptionsInput): LocaleOption[] {
  const accountLocales = parseAccountSelectedLanguages(accountSelectedLanguages);
  if (accountLocales.length === 0) return [...UI_LANGUAGE_OPTIONS];

  const accountLocaleSet = new Set([DEFAULT_CONTENT_LOCALE, ...accountLocales]);
  const accountOptions = UI_LANGUAGE_OPTIONS.filter(({ locale }) => accountLocaleSet.has(locale));
  return [...accountOptions];
}

export function getUnrecognizedAccountLocales(accountSelectedLanguages: string): string[] {
  const bundledLocales = new Set<string>(UI_LANGUAGE_OPTIONS.map(({ locale }) => locale));
  return parseAccountSelectedLanguages(accountSelectedLanguages)
    .filter((locale) => !bundledLocales.has(locale));
}

function parseAccountSelectedLanguages(accountSelectedLanguages: string): string[] {
  return [...new Set(
    accountSelectedLanguages
      .split(',')
      .map(canonicalizeLocale)
      .filter(Boolean),
  )];
}
